import React, { useEffect, useLayoutEffect, useState } from "react";
import styles from "./styles/SettingPage.module.css";
import { Col, Container, Row, Stack } from "react-bootstrap";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { APP_TITLE_SUFFIX, SETTING_SUB_ROUTE } from "@constants";
import clsx from "clsx";
import { useWindowSize } from "@hooks";

const SettingPage = () => {
  // state
  const [activeTab, setActiveTab] = useState(SETTING_SUB_ROUTE.PROFILE);

  // variables
  const navLinks = [
    {
      target: SETTING_SUB_ROUTE.PROFILE,
      content: "Profile",
      icon: <i className="bi bi-person-circle" />,
    },
    {
      target: SETTING_SUB_ROUTE.ACCOUNT,
      content: "Account",
      icon: <i className="bi bi-shield-lock" />,
    },
  ];

  // logics before hooks

  // hooks
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // logics
  const handleNavigate = (target) => {
    navigate(target, { replace: true });
    setActiveTab(target);
  };

  // UI partials
  const navigator = (
    <Stack direction={width < 992 ? "horizontal" : "vertical"}>
      {navLinks.map((link, index) => (
        <button
          key={index}
          className={clsx(
            styles.link,
            link.target === activeTab ? styles.linkActive : ""
          )}
          onClick={() => handleNavigate(link.target)}
        >
          <Stack direction="horizontal" gap={2}>
            {link.icon}
            {link.content}
          </Stack>
        </button>
      ))}
    </Stack>
  );

  // effects
  useEffect(() => {
    const currentTab = [...pathname.split("/")].pop();
    if (currentTab !== activeTab) setActiveTab(currentTab);
  }, [pathname]);

  useLayoutEffect(() => {
    document.title = `Setting | ${APP_TITLE_SUFFIX}`;
  }, []);

  // render
  return (
    <Container>
      <Row>
        <Col xs={12} xl={{ span: 11, offset: 1 }} className="my-4">
          <Stack direction="horizontal" gap={3} className="h4 mb-0">
            <i className="bi bi-gear" />
            <span>Setting</span>
          </Stack>
        </Col>
      </Row>
      <Row className="gy-4">
        <Col xs={12} lg={3} xl={{ span: 2, offset: 1 }}>
          {navigator}
        </Col>
        <Col xs={12} lg={9} xl={8}>
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
};

/* required: display name */
SettingPage.displayName = "SettingPage";

/* required: props types */
SettingPage.propTypes = {};

/* required: default props */
SettingPage.defaultProps = {};

export { SettingPage };
